import DataLayer from "./DataLayer";

export default (promotion) => {
    DataLayer.track({
        event: "promotion_click",
        ecommerce: {
            promoClick: {
                promotions: [
                    {
                        id: promotion.id,
                        name: promotion.name,
                        creative: promotion.creative,
                        position: promotion.position,
                    },
                ],
            },
        },
    });
};
